import { RouterOutlet } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerModule } from "ngx-spinner";
import { PrimeNG } from 'primeng/config';
import { DraganddropModule } from "draganddrop";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NgxSpinnerModule,
    DraganddropModule
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit {

  constructor(private primeng: PrimeNG) {}

  ngOnInit() {
    this.primeng.ripple.set(true);
  }

}
